import { FC } from "react";
import TextInput from "../../../../assets/components/Inputs/TextInput/TextInput";
import "./ProjectSubRowFeature.scss";
import IconSprite from "../../Img/projects_sprite.svg";
import { Feature } from "../../../../models/models";
import { StateRow } from "../ProjectSubRowFeatures/ProjectSubRowFeatures";
import { Field, Formik } from "formik";
import * as Yup from 'yup';
import ImageSprite from "../../../../assets/components/ImageSprite/ImageSprite";

interface Props extends Feature {
    state: StateRow;
    updateFeatureName: ({ id, name }: Feature) => void;
    closeUpdateFeature: () => void;
}

const validateSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
});

const EditorFeatureProject: FC<Props> = ({ id, name, state, updateFeatureName, closeUpdateFeature }) => {
    return <Formik
        initialValues={{
            name,
        }}
        validationSchema={validateSchema}
        onSubmit={() => { }}
    >
        {({ isValid, values }) => {
            return (
                <div className="feature">
                    {state === "default" ?
                        <div>
                            {name}
                        </div>
                        :
                        <>
                            <Field
                                id="name"
                                name="name"
                                as={TextInput}
                            />

                            <button
                                type="button"
                                onClick={() => closeUpdateFeature()}
                                className="feature_button"
                            >
                                <ImageSprite iconSprite={`${IconSprite}#close`} />
                            </button>

                            <button
                                disabled={!isValid}
                                type="submit"
                                onClick={() => {
                                    updateFeatureName({ id, name: values.name })
                                }}
                                className="feature_button">
                                <ImageSprite iconSprite={`${IconSprite}#approve`} />
                            </button>
                        </>
                    }
                </div >
            );
        }}
    </Formik>
}

export default EditorFeatureProject;